import React from 'react'

import NavbarV2 from '../components/navbar-v2'
import BannerOne from '../components/banner-one'
import FeaturesOne from '../components/features-one'
import AboutV2One from '../components/about-v2-one'
import AboutV2Two from '../components/about-v2-two'
import Screenshot from '../components/screenshot'
import Faq from '../components/faq'
import Download from '../components/download'
import Contact from '../components/contact'
import PWAInstallButton from '../components/PWAInstallButton'

import FooterV2 from '../components/footer-v2'

export default function IndexFive() {
  return (
    <>
    <NavbarV2 />
    <BannerOne/>
    
    <section className="relative md:py-24 py-16" id="features">
        <div className="container relative">
            <div className="grid grid-cols-1 pb-6 text-center">
                <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">Genel ÖZELLİKLER</h6>
                <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">İster tek başınıza ister sevdiklerinizle birlikte</h4>

                <p className="text-slate-400 max-w-xl mx-auto">Kur’an-ı Kerim ve Risale-i Nur Külliyatı’nı ister bireysel ister grup halinde okuyarak ilerlemenizi takip etmenizi sağlayan, pratik ve kullanıcı dostu bir mobil uygulamadır. </p>
            </div>

            <FeaturesOne/>
        </div>

        <div className="container relative md:mt-24 mt-16">
            <AboutV2One/>
        </div>

        <div className="container relative md:mt-24 mt-16">
            <AboutV2Two/>
        </div>
    </section>

    <section className="relative md:py-24 py-16 hidden md:block" id="screenshot">
        <div className="container relative">            <div className="grid grid-cols-1 pb-6 text-center">
                <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">Uygulama içi Görüntüler</h6>
                <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">Karmaşadan uzak, sade bir tasarım</h4>

                <p className="text-slate-400 max-w-xl mx-auto">Her şey tam da olması gerektiği yerde. HatimTakip’in basit ve şık arayüzüyle, ne yapmanız gerektiğini düşünmeden hemen okumaya başlayabilirsiniz.</p>
            </div>

            <Screenshot/>
        </div>
    </section>

    <section className="relative overflow-hidden md:py-24 py-16" id="faqs">
        <Faq/>
    </section>
    
    <section className="relative md:py-24 py-16 bg-slate-50/50 dark:bg-slate-800/20" id="download">
        <Download/>
    </section>
    <section className="relative md:py-24 py-16 bg-slate-50/50 dark:bg-slate-800/20" id="contact">
        <Contact/>
    </section>

    <FooterV2 />
    
    {/* PWA Install Button - Sadece mobilde görünür */}
    <PWAInstallButton />

    </>
  )
}
